import { useState, useContext } from 'react';
import { Form, Grid, Button, Segment, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import Center from '../../components/Auth/Center';
import HeaderLogo from '../../components/Auth/HeaderLogo';
import CenterMessage from '../../components/CenterMessage';
import AppContext from '../../context/HeaderContext';
import CardInput from '../../components/CardInput';
import { postAPI } from '../../libs/fetchAPI';
import { loadStripe } from "@stripe/stripe-js";
import {
	Elements,
	CardElement,
	useStripe,
	useElements,
} from "@stripe/react-stripe-js";
import { strip_publishable_key } from '../../config';

const Container = styled.div`

`;

const CustomCenter = styled(Center)`
	margin-top: 5px;
`;

const GridContainer = styled.div`
	position: relative;
	padding: 15px;
	width: 900px;
`;

const LeftContainer = styled.div`
	margin-top: 0px;
`;

const CustomFormInput = styled.input`
	padding: 13px !important;
`;

const CustomHeader = styled(Header)`
	margin: 0 0 20px 0 !important;
`;

const stripe_promise = loadStripe(strip_publishable_key);

function PaymentStripe() {
	return (
		<Container>
			<Center>
				<HeaderLogo />
			</Center>

			<CustomCenter>
				<GridContainer>
					<Grid columns={2} relaxed="very" celled="internally">
						<Grid.Column>
							<LeftContainer>
								<h1>Start your free 7 day trial</h1>

								<p>
									You can cancel anytime during your free trial and you will not be billed anything.
									After the 7 day free trial you will automatically be billed at a rate of $29.99/month.
									If you add more that one user to your account you will be charged an additional $9.95/month per user.
								</p>

								<p>To learn more about pricing, visit <a href="/">testreporter.io/pricing</a></p>
							</LeftContainer>
						</Grid.Column>

						<Grid.Column>
							<CustomHeader as="h2">
								<p>Billing Details</p>
								<p>All transactions are secure and encrypted.</p>
							</CustomHeader>
							<Elements stripe={stripe_promise}>
								<PaymentForm />
							</Elements>
						</Grid.Column>
					</Grid>
				</GridContainer>
			</CustomCenter>
		</Container>
	);
}

function PaymentForm() {
	const { user, updateUser }            = useContext(AppContext);
	const [ errors, setErrors ]           = useState([]);
	const [ saving, setSaving ]           = useState(false);
	const [ name_on_card, setNameOnCard ] = useState(`${user.first_name} ${user.last_name}`);
	const stripe   = useStripe();
	const elements = useElements();

	const handleNameOnCardChange = (e) => {
		setNameOnCard(e.target.value);
	}

	const submitPaymentMethod = async (e) => {
		e.preventDefault();
		setSaving(true);
		setErrors([]);

		const card = elements.getElement(CardElement);
		const { error, paymentMethod } = await stripe.createPaymentMethod({
			type : `card`,
			card,
			billing_details : {
				name : name_on_card,
			}
		});

		if(error) {
			setErrors([error.message]);
			setSaving(false);
			return;
		}

		// Create the subscription
		const { subscription } = await postAPI(`/subscriptions`, {
			payment_method : paymentMethod,
			update         : false,
		});

		const { pending_setup_intent } = subscription;

		if(!pending_setup_intent) {
			updateUser({
				...user,
				...{ payment_status : `active` }
			});

			window.location = `/`;

			return;
		}

		// This is for 3D auth
		if(pending_setup_intent.status === `requires_action`) {
			stripe.confirmCardSetup(pending_setup_intent.client_secret).then((result) => {
				if(result.error) {
					setErrors([result.error.message]);
					setSaving(false);
				}
				else {
					updateUser({
						...user,
						...{ payment_status : `active` }
					});

					window.location = `/`;

					return;
				}
			});
		}
		// This is for card invalid/declined
		else if(pending_setup_intent.status === `requires_payment_method`) {
			// Collect new payment
			setErrors([`Invalid payment. Please enter payment again.`]);
			setSaving(false);
		}
	}

	return (
		<Form onSubmit={submitPaymentMethod}>
			<Form.Field>
				<label>Name on card</label>
				<CustomFormInput
					placeholder="Name on card"
					name="name_on_card"
					onChange={handleNameOnCardChange}
					value={name_on_card || ``}
				></CustomFormInput>
			</Form.Field>

			<Segment>
				<CardInput />
			</Segment>

			<Button loading={saving} fluid primary>Submit (step 2 of 2)</Button>

			{errors.length > 0 &&
				<CenterMessage negative>
					{errors.map((error, i) => <p key={i}>{error}</p>)}
				</CenterMessage>
			}
		</Form>
	);
}

export default PaymentStripe;
